'use client'

import React from 'react'
import { ActionIcon } from '@mantine/core'
import { NavTheme } from './theme'

interface IconCircleButtonProps {
    theme: NavTheme
    onClick?: () => void
    children: React.ReactNode
    'data-testid'?: string
    'aria-label'?: string
}

export function IconCircleButton({ theme, onClick, children, ...rest }: IconCircleButtonProps) {
    return (
        <ActionIcon
            variant="default"
            radius="xl"
            size={44}
            onClick={onClick}
            c={theme.actionIconColor}
            bd={theme.border}
            __vars={{
                '--ai-bg': 'transparent',
                '--ai-hover': 'var(--gm-bg-highlight-cont, rgba(45, 26, 255, 0.1))',
            }}
            {...rest}
        >
            {children}
        </ActionIcon>
    )
}
